import {
   AnnulledPrescription,
   isMagistralDrugPrescription,
   isStandardPrescription,
   RecipientCategory,
   ValidatedPrescription,
   ValidatedPrescriptionPackage,
} from '~libs.shared.prescription';

import { mapPrescriptionToSentStandardPrescription } from './standardPrescription/SentStandardPrescriptionItem.utils';
import { SentPrescriptionItem, SentPrescriptionPackageItem } from './SentPrescriptionPackagesList.types';
import { mapPrescriptionToSentMagistralPrescription } from './magistralDrugPrescription/SentMagistralDrugPrescriptionItem.utils';

const mapSentPrescriptionToItem = (
   prescription: AnnulledPrescription | ValidatedPrescription,
   recipientCategory: RecipientCategory | undefined
): SentPrescriptionItem => {
   if (isStandardPrescription(prescription)) {
      return mapPrescriptionToSentStandardPrescription(prescription, recipientCategory);
   }

   if (isMagistralDrugPrescription(prescription)) {
      return mapPrescriptionToSentMagistralPrescription(prescription, recipientCategory);
   }

   throw new Error('Not supported type of prescription.');
};

export const mapSentPrescriptionsToSentPrescriptionItems = (
   prescriptions: AnnulledPrescription[] | ValidatedPrescription[],
   recipientCategory: RecipientCategory | undefined
): SentPrescriptionItem[] => {
   return prescriptions.map((prescription) => mapSentPrescriptionToItem(prescription, recipientCategory));
};

export const mapPrescriptionPackageToSentPrescriptionPackage = (
   prescriptionPackage: ValidatedPrescriptionPackage
): SentPrescriptionPackageItem => {
   return {
      id: prescriptionPackage.id,
      accessCode: prescriptionPackage.accessCode,
      packageStatus: prescriptionPackage.packageStatus,
      prescriptions: mapSentPrescriptionsToSentPrescriptionItems(
         prescriptionPackage.prescriptions,
         prescriptionPackage.recipientCategory
      ),
   };
};
